module.exports = "/static/assets/0d0e22a9ab7d714a8159e54eee82a4c3.png";